import styled from 'styled-components';

const HeaderRow = styled.tr`
  & > td:first-child {
    border-bottom: 2px solid darkgray;
  }
  background: #333 !important;

  &:hover {
    background: #333 !important;
  }
`;

const CenteredTd = styled.td`
  text-align: center;
  vertical-align: middle !important;
`;

const Title = styled.p`
  font-weight: bold;
  margin-top: 0;
  margin-bottom: 0;
`;

type Props = React.PropsWithChildren<unknown>;
export const ComiteHeader = (props: Props) => {
  const { children } = props;
  return (
    <HeaderRow>
      <CenteredTd colSpan={10}>
        <Title className="text-light">{children}</Title>
      </CenteredTd>
    </HeaderRow>
  );
};
